module.exports = __webpack_public_path__ + "media/icons/mailing-instagram@2x-29ea1dfd.png";